var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.name,attrs:{"data-tea-expose":"create_adgroup_too_narrow_expose"}},[_c('tip-alert',{attrs:{"title":_vm.$t('audience_estimate_tips_too_narrow'),"type":'warning',"isTextCircle":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }